import { Card } from 'components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import { locale } from 'locales/i18nManager';
import { useTranslation } from 'react-i18next';
import { DailyStatus } from 'services/api/models/SymptomTrackingDTO';

export type CalendarTabsProps = {
  daysWithNotes: DailyStatus[];
};

const CalendarTabs: React.FC<CalendarTabsProps> = ({ daysWithNotes }) => {
  const { t } = useTranslation();

  const lastItemKey = daysWithNotes[daysWithNotes.length - 1]?.date || 'nokey';

  if (!daysWithNotes.length) {
    return (
      <div className="text-subtle-foreground">
        <p className="m-0">{t('symptomTracking.notes.noNotesYet')}</p>
      </div>
    );
  }

  return (
    <Tabs defaultValue={lastItemKey} className="w-full">
      {/* two-line day labels: the list grows with them and scrolls sideways */}
      <TabsList className="h-auto w-full justify-start gap-1 overflow-x-auto p-1 rounded-xl">
        {daysWithNotes.map(status => {
          const statusDate = new Date(status.date as string);
          return (
            <TabsTrigger
              key={status.date}
              value={status.date as string}
              className="h-auto flex-none flex-col gap-0 px-3 py-1.5"
            >
              <span className="text-xs font-normal capitalize">
                {statusDate.toLocaleDateString(locale, { weekday: 'long' }).slice(0, 2)}
              </span>
              <span className="text-base">{statusDate.toLocaleDateString(locale, { day: 'numeric' })}</span>
            </TabsTrigger>
          );
        })}
      </TabsList>
      {daysWithNotes.map(status => {
        const statusDate = new Date(status.date as string);
        const shortDate = statusDate.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
        return (
          <TabsContent key={status.date} value={status.date as string}>
            <Card className="rounded-xl bg-muted px-4">
              {status.comment && (
                <>
                  <h4 className="text-lg">
                    {t('symptomTracking.graphs.notes')} - {shortDate}
                  </h4>
                  <p className="whitespace-pre-line">{status.comment}</p>
                </>
              )}
              {status.extra_symptoms && (
                <>
                  <h4 className="text-lg mt-3">
                    {t('symptomTracking.graphs.otherSymptoms')}
                    {!status.comment && (
                      <>
                        {' - '}
                        {shortDate}
                      </>
                    )}
                  </h4>
                  <p className="whitespace-pre-line">{status.extra_symptoms}</p>
                </>
              )}
            </Card>
          </TabsContent>
        );
      })}
    </Tabs>
  );
};
export default CalendarTabs;
